exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".row[_v-31b5a704]{padding-top:15px}.disabled-color[_v-31b5a704]{opacity:.2}.active-color[_v-31b5a704]{opacity:1}.product-name[_v-31b5a704]{padding-bottom:0}.product-price[_v-31b5a704]{margin-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-31b5a704&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Product/Product-detail-general.vue
// module id = 415
// module chunks = 0